(function () {
  'use strict';
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'nl') return;
  var marker = document.getElementById('gw-nl-entry-20261016-v1');
  if (!marker || marker.getAttribute('data-gw-nl-country') !== 'NL') return;
  var root = (marker.getAttribute('data-gw-nl-root') || '').replace(/\/+$/, '');
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/^\/nl(?:-nl)?$/.test(root) || path !== marker.getAttribute('data-gw-nl-path')) return;
  var key = marker.getAttribute('data-gw-nl-entry');
  var tails = {
    recorder: '/pages/gladwares-ai-recorder', cart: '/cart', faq: '/pages/faqs',
    contact: '/pages/content', refund: '/policies/refund-policy',
    privacy: '/policies/privacy-policy', shipping: '/policies/shipping-policy',
    terms: '/policies/terms-of-service', tracking: '/apps/17TRACK',
    recorder_product: '/products/magnetic-ai-powered-voice-recorder',
    headphones: '/products/2026-noise-cancelling-wireless-headphones',
    hub: '/products/8-in-1-dual-usb-c-hub',
    folding_keyboard: '/products/folding-keyboard-with-smart-trackpad',
    air_mouse: '/products/mini-m5-dual-mode-wireless-air-mouse-keyboard'
  };
  if (!tails[key] || path.toLowerCase() !== (root + tails[key]).toLowerCase()) return;
  var images;
  try { images = JSON.parse(marker.textContent).images; } catch (error) { return; }
  var alts = {
    'lux-img-1': 'Gladwares MemoryCard AI Pro: opnemen, transcriberen en samenvatten',
    'lux-img-1-1': 'Gladwares MemoryCard AI Pro: opnemen, transcriberen en samenvatten',
    'lux-img-2': 'Van gesprek naar duidelijke tekst',
    'lux-img-3': 'Leg ideeën, afspraken en instructies vast',
    'lux-img-4': 'Transcriptie, kernpunten en actiepunten',
    'lux-img-5': 'Beheer je opnamen in de DOWAY-app',
    'lux-img-6': 'Neem gesprekken op en bekijk de details later terug',
    'lux-img-7-1': 'Vergaderingen opnemen en samenvatten',
    'lux-img-7-2': 'Kernpunten uit je gesprekken',
    'lux-img-7-3': 'Notities voor studie en werk',
    'lux-img-7-4': 'Overzicht van afspraken en actiepunten',
    'lux-img-8-1': 'Opnemen, uitschrijven en samenvatten',
    'lux-img-8-2': 'Vind de belangrijkste punten',
    'lux-img-8-3': 'Voorbeeld van een vergadersamenvatting met kernpunten, besluiten en vervolgstappen.',
    'lux-img-8-4': 'Vind elk moment van het gesprek terug',
    'lux-img-9-1': 'Een concept voor een opvolgmail',
    'lux-img-9-2': 'Klantgegevens bij de hand',
    'lux-img-9-3': 'Voorbeeld van een AI-suggestie: een korte vergelijking voorbereiden ter beoordeling.',
    'lux-img-9-4': 'Voorbeeld van een klantprofiel met bijgewerkte informatie uit twee gesprekken.',
    'P5-1': 'Druk op de knop en leg het vast',
    'P5-2': 'Transcriptie en samenvattingen zonder abonnement',
    'P5-3': '152 talen en overzicht in de DOWAY-app',
    'P5-4': 'Opnemen, uitschrijven en samenvatten',
    'P5-5': '64 GB met tot 450 uur opslag',
    'P5-6': 'Dunne magnetische recorder in bankpasformaat'
  };
  function setImage(img, id) {
    var url = images[id];
    if (!img || img.tagName !== 'IMG' || !url) return;
    var hero = id === 'lux-img-1' || id === 'lux-img-1-1';
    var mobile = window.matchMedia('(max-width: 767.4999px)').matches;
    if (hero) {
      var visible = mobile ? id === 'lux-img-1-1' : id === 'lux-img-1';
      img.setAttribute('loading', visible ? 'eager' : 'lazy');
      img.setAttribute('fetchpriority', visible ? 'high' : 'auto');
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('alt', alts[id] || '');
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', url);
      source.setAttribute('data-srcset', url);
    });
  }
  function imagesOnce() {
    if (key !== 'recorder') return;
    Object.keys(images).forEach(function (id) {
      if (id.indexOf('lux-img-') === 0) setImage(document.getElementById(id), id);
    });
    var thumbs = document.querySelectorAll('#lux-thumb-strip .lux-thumb');
    if (thumbs.length !== 6) return;
    thumbs.forEach(function (thumb, index) {
      var id = 'P5-' + (index + 1);
      thumb.setAttribute('data-nl-image', images[id]);
      thumb.setAttribute('data-nl-nl-image', images[id]);
      thumb.setAttribute('data-image', images[id]);
      thumb.setAttribute('aria-label', alts[id]);
      setImage(thumb.querySelector('img'), id);
    });
    var active = document.querySelector('#lux-thumb-strip .lux-thumb.is-active') || thumbs[0];
    setImage(document.getElementById('lux-main-image'), 'P5-' + (Array.prototype.indexOf.call(thumbs, active) + 1));
  }
  function localLinks(container) {
    var permitted = Object.keys(tails).map(function (name) { return tails[name].toLowerCase(); });
    container.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (error) { return; }
      if (url.origin === window.location.origin) {
        var relative = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
        if (permitted.indexOf(relative.replace(/\/+$/, '').toLowerCase()) !== -1) {
          var target = root + relative + url.search + url.hash;
          if (a.getAttribute('href') !== target) a.setAttribute('href', target);
        }
      } else if (url.hostname === 'shopify.com' && url.pathname === '/9182642261/account/orders') {
        url.searchParams.set('locale', 'nl');
        url.searchParams.set('region_country', 'NL');
        a.setAttribute('href', url.href);
      }
    });
  }
  function bundleText() {
    document.querySelectorAll('#lux-bundle-area .engrave-input').forEach(function (input) {
      input.setAttribute('placeholder', 'Voer je naam of tekst in');
    });
  }
  function miniCartText() {
    document.querySelectorAll('.mini-cart__item').forEach(function (item) {
      if (!item.querySelector('a[href*="/products/magnetic-ai-powered-voice-recorder"]')) return;
      item.querySelectorAll('.line-item').forEach(function (line) {
        if (line.childElementCount === 0 && /^\s*Engraving(?=\s|:|\d|$)/.test(line.textContent)) {
          line.textContent = line.textContent.replace(/^(\s*)Engraving/, '$1Gravure');
        }
      });
    });
    document.querySelectorAll('.cart_content').forEach(localLinks);
  }
  function init() {
    imagesOnce();
    localLinks(document);
    bundleText();
    miniCartText();
    var bundle = key === 'recorder' ? document.getElementById('lux-bundle-area') : null;
    if (bundle && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          bundleText();
        });
      }).observe(bundle, {childList: true, subtree: true});
    }
    document.addEventListener('gw-nl-cart-rendered', miniCartText);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

